import {
  required,
  helpers 
} from 'vuelidate/lib/validators'

export default {
  name: {
    required,
    name: helpers.regex('name', /.+\s.+/),
  },

  birthdate: {
    required,
    birthdate: helpers.regex('birthdate', /^(?:0[1-9]|[12]\d|3[01])([\/.-])(?:0[1-9]|1[012])\1(?:19|20)\d\d$/)
  },

  gender: {
    required
  }
}
